import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Privacy from './Privacy';
import Home from './pages/Home';
import Codex from './pages/Codex';
import Automata from './pages/Automata';
import Opteron from './pages/Opteron';
import Terms from './Terms';
import License from './License';
import About from './About';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/license" element={<License />} />
        <Route path="/about" element={<About />} />
        <Route path="/codex" element={<Codex />} />
        <Route path="/automata" element={<Automata />} />
        <Route path="/opteron" element={<Opteron />} />
      </Routes>
    </Router>
  );
}

export default App;
